/**
 * Created by Ning Jiang on 1/14/2020.
 */

import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {Timeline, TimelineLite} from "gsap";
import {DeadwoodGameConfig} from "../../DeadwoodGameConfig";
import {DeadwoodSoundConfig} from "../../DeadwoodSoundConfig";
import {DeadwoodReelView} from "../../reel/DeadwoodReelView";
import {DeadwoodParsedGameData} from "../../server/data/DeadwoodParsedGameData";

export class DeadwoodScatterSymbolWPController extends WinPresentationController {

    private _timeline:TimelineLite | null;
    private _freespinTriggered:boolean;
    private _scatterPositions:number[];
    private _bonusTriggered:boolean;
    private _bonusPositions:number[];
    private _hasBetWayWin:boolean;
    private _mode:string;

    constructor(indexes:[number, number]) {
        super(indexes, {name : "ScatterWin"})
    }

    protected parseFeatureGameData(data:DeadwoodParsedGameData):void {
        this._mode = data.mode;
        this._freespinTriggered = data.freespinTriggeredThisSpin;
        this._scatterPositions = data.scatterPositions!;
        this._bonusTriggered = data.bonusTriggeredThisSpin;
        this._bonusPositions = data.bonusPositions;
        this._hasBetWayWin = data.betWins != null && data.betWins.length > 0;

        if(this._mode != GameMode.NORMAL) {
            return;
        }

        if(this._freespinTriggered && (
            this._scatterPositions == null ||
            this._scatterPositions[1] === -1 ||
            this._scatterPositions[2] === -1 ||
            this._scatterPositions[3] === -1)) {
            debugger;
            throw new Error("DeadwoodScatterSymbolWPController.parseFeatureGameData(): scatterPositions data doesn't match the feature.")
        }
    }

    protected hasWin():boolean {
        if(this._mode !== GameMode.NORMAL) {
            return false;
        }
        return this._freespinTriggered && (this._hasBetWayWin || this._bonusTriggered);
    }

    protected startWinPresentation():void {
        const timeline:TimelineLite = new TimelineLite({paused : true, onComplete : () => this.finish()});
        timeline.add(this.getScatterSymbolAnimation(1, this._scatterPositions[1], false), 0);
        timeline.add(this.getScatterSymbolAnimation(2, this._scatterPositions[2], false), 0);
        timeline.add(this.getScatterSymbolAnimation(3, this._scatterPositions[3], false), 0);
        if(this._bonusTriggered) {
            timeline.add(this.getBonusSymbolAnimation(0, this._bonusPositions[0], false), 0);
            timeline.add(this.getBonusSymbolAnimation(4, this._bonusPositions[4], false), 0);
            timeline.add(() => SlotGame.sound.playEffect(DeadwoodSoundConfig.instance.SUPER_HIGHLIGHT), 0);
        } else {
            timeline.add(() => SlotGame.sound.playEffect(DeadwoodSoundConfig.instance.SCATTER_HIGHLIGHT), 0);
        }

        this._timeline = timeline;
        this._timeline.play();
    }

    private getScatterSymbolAnimation(reelId:number, symbolId:number, isAbort:boolean):Timeline | null {
        const symbol:StateReelSymbol | null = Reels.getSymbol(reelId, symbolId);
        if(symbol == null) {
            debugger;
            return new TimelineLite();
        }

        (<DeadwoodReelView>Reels.getReel(reelId)!.view).addSymbolToWinContainer(symbol);
        return symbol.changeState({
            state : DeadwoodGameConfig.instance.SYMBOL_STATES.win,
            setStack : true,
            fadeInDuration : isAbort ? 0 : 0.1,
            frames : isAbort ? [-1, -1] : [0]
        })!;
    }

    private getBonusSymbolAnimation(reelId:number, symbolId:number, isAbort:boolean):Timeline | null {
        const symbol:StateReelSymbol | null = Reels.getSymbol(reelId, symbolId);
        if(symbol == null) {
            debugger;
            return new TimelineLite();
        }

        (<DeadwoodReelView>Reels.getReel(reelId)!.view).addSymbolToWinContainer(symbol);
        return isAbort ?
            symbol.changeState({
                state : DeadwoodGameConfig.instance.SYMBOL_STATES.broken,
                replay : true,
                fadeInDuration : 0.01,
            })!
            : symbol.changeState({
                state : DeadwoodGameConfig.instance.SYMBOL_STATES.landing,
                replay : true,
                fadeInDuration : 0.1
            })!;
    }

    protected stopWinPresentation(isAborted:boolean):void {
        if(this._timeline && this._timeline.isActive()) {
            this._timeline.pause();
            this._timeline.kill();
            this._timeline = null;
        }
        this.getScatterSymbolAnimation(1, this._scatterPositions[1], true);
        this.getScatterSymbolAnimation(2, this._scatterPositions[2], true);
        this.getScatterSymbolAnimation(3, this._scatterPositions[3], true);
        if(this._bonusTriggered) {
            this.getBonusSymbolAnimation(0, this._bonusPositions[0], true);
            this.getBonusSymbolAnimation(4, this._bonusPositions[4], true);
        }
    }
}